import React from 'react';

// Styles & Assets
import styles from './ScoresManagementPage.module.css';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import ScoresManagement from '../../components/ScoresManagementPage/ScoresManagement/ScoresManagement';
// import ButtonAdd from '../../components/UI/ButtonAdd/ButtonAdd';

// Language
import { useTranslation } from 'react-i18next';

// ScoresManagementPage: renders a toolbar and the ScoresManagementComponent.
const ScoresManagementPage: React.FC = () => {

    const { t } = useTranslation(); 
    
    return (
        <div className={styles.scoresPageContainer}>
            <Toolbar text={t('administration')} link='/home/administration'>
                {/* <div className={styles.buttonWrapper}>
                    <ButtonAdd link='add-score' text={t('add_score')}/>
                </div> */}
            </Toolbar>
            <ScoresManagement />
        </div>
    );
};

export default ScoresManagementPage;